// import Dashboard from '../../../images/Dashboard.svg';
import { Dashboard, Currentlessons, Student, Help, Payment, LogOut } from '../../../images/images';
import PersonalData from '../../../images/PersonalData.svg';
import Notification from '../../../images/Notification.svg';
import Selectedlessons from '../../../images/Selectedlessons.svg';
import Homework from '../../../images/Homework.svg';
import CurrentHomework from '../../../images/CurrentHomework.svg';
// import Payment from '../../../images/Payment.svg';
// import Help from '../../../images/Help.svg';
// import Student from '../../../images/Student.svg';
// import Lesson from '../../../images/Lesson.svg';
// import LogOut from '../../../images/LogOut.svg';
import { useTranslation } from 'react-i18next';
import i18n from '../../../../src/translateFolder/i18n.js';
// const { t, i18n: { changeLanguage } } = useTranslation();

// export const ProfileSidebarArr = [
//   {
//     icon: Dashboard,
//     name: t('Dashboard'),
//     slug: 'dashboard'
//   },
//   {
//     icon: Currentlessons,
//     name: 'Current lessons',
//     slug: 'currentLessons'
//   },
//   {
//     icon: Student,
//     name: 'Profile',
//     slug: 'profile'
//   },
//   {
//     icon: Help,
//     name: 'Help',
//     slug: 'help'
//   },
//   {
//     icon: Payment,
//     name: 'Visit history',
//     slug: 'visithistory'
//   },
//   {
//     icon: LogOut,
//     name: 'Log out',
//     slug: 'logOut',
//   },
// ];
export const ProfileSidebarArrll = () => {
  const { t } = useTranslation();

  return [
    {
      icon: Dashboard,
      name: t('dashboard'),
      slug: 'dashboard'
    },
    {
      icon: Currentlessons,
      name: t('currentLessons'),
      slug: 'currentLessons'
    },
    {
      icon: Student,
      name: t('profile'),
      slug: 'profile'
    },
    {
      icon: Help,
      name: t('helpp'),
      slug: 'help'
    },
    {
      icon: Payment,
      name: t('visitHistoryy'),
      slug: 'visithistory'
    },
    {
      icon: LogOut,
      name: t('logOut'),
      slug: 'logOut',
    },
  ];
};

export const allVideoLessons = [
  'HTML/HTML 5',
  'CSS/CSS3',
  'JavaScript',
  'BootStrap',
  'jQuery',
  'ECMAScript(ES6)',
  'REACT/REDUX',
  'PHP',
  'Laravel',
  'Node JS',
  'MySQL',
  'Wordpress',
  'Login With FB',
  '.htacces',
  'Angular JS',
  'Server',
  'OOP/MVC',
];

export const homeworkes = [
  {
    id: 1,
    name: 'Ներածություն',
    addition: 'Սկզբնական թեգեռի դասավորությունը',
    time: '06։29 sec.',
  },
  {
    id: 2,
    name: 'Աշխատանք տեքստի հետ',
    addition: 'Ֆոնային գույն բացատ տառատեսակներ ',
    time: '13։00 sec.',
  },
  {
    id: 3,
    name: 'Տառաչափ եվ աղյուսակներ',
    addition: '/Կից կարող եք տեսնել հավելում/Առաջադրանք',
    time: '20։04 sec.',
  },
];



